export const USER_SESSION = 'id_8dffac2d-195e';
